var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatYouGet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_431_10763)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#F8778D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9998 20.667C35.5998 20.667 20.6665 35.6003 20.6665 54.0003C20.6665 58.4337 21.5332 62.7003 23.1332 66.567L40.6665 49.0003L51.6665 58.267L62.5998 47.3337H57.3332V40.667H73.9998V57.3337H67.3332V52.067L52.0332 67.3337L41.0665 58.0337L26.3998 72.7003C29.4541 77.2093 33.567 80.9009 38.3786 83.452C43.1902 86.003 48.5538 87.3358 53.9998 87.3337H80.6665C84.3332 87.3337 87.3332 84.3337 87.3332 80.667V54.0003C87.3332 35.6003 72.3998 20.667 53.9998 20.667ZM78.9998 82.3337C77.1665 82.3337 75.6665 80.8337 75.6665 79.0003C75.6665 77.167 77.1665 75.667 78.9998 75.667C80.8332 75.667 82.3332 77.167 82.3332 79.0003C82.3332 80.8337 80.8332 82.3337 78.9998 82.3337Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_431_10763",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_10763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_10763",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatYouGet2);
export default __webpack_public_path__ + "static/media/WhatYouGet2.0b4c444def05b890d5c5cde05bc8e0fb.svg";
export { ForwardRef as ReactComponent };